/** Minimum puzzle level to activate the super lollipop */
export const superLollipopUnlockLevel = 100;

/** Win streak needed to activate the super lollipop */
export const superLollipopWinStreakRequiredDefault = 10;
